import { render, staticRenderFns } from "./schemeProject.vue?vue&type=template&id=298be734&"
import script from "./schemeProject.vue?vue&type=script&lang=js&"
export * from "./schemeProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports